import axios from 'axios'

const HOST_URL = process.env.VUE_APP_API_HOST

export default {
    getBookingData (payload = {}) {
        return axios.get(`${HOST_URL}/booking`, {
            params: payload
        })
    },
    getBooking (payload = {'page-limit': 9999}) {
        return axios.get(`${HOST_URL}/booking`, {
            params: payload
        })
    },
    getBookKeepingData (payload = {}) {
        return axios.get(`${HOST_URL}/book-keeping-data`, {
            params: payload
        })
    },
    createAct(payload = {}) {
        return axios.post(`${HOST_URL}/create-reconciliation-act`, payload)
    }
}
